import AdvertisingDisclosure from './AdvertisingDisclosure.js'
import logo from "../../assets/images/new_logo.png";
import classes from './Header.module.css'

function Header({ handleOpen }) {
    return(
        <div className={classes.appHeader}>
            <div className={classes.headerContainer}>
                <img alt="logo" src={logo} className={classes.appLogo}/>
                <AdvertisingDisclosure handleOpen={handleOpen} />
            </div>
        </div>
    )
}

export default Header